import { atom , useSetRecoilState, useRecoilValue, useResetRecoilState} from "recoil";




export const customerTransAtom = atom({key:'customer_trans_atom',default:{transation_history:[],
    transation_type:[]}});


export const SetCustomerTransListAtom = () => useSetRecoilState(customerTransAtom);
export const ResetCustomerTransListAtom = () => useResetRecoilState(customerTransAtom);
export const GetCustomerTransListAtom = () => useRecoilValue(customerTransAtom);
